/**
 * Generates an array of search keywords from product data.
 * Used for Firestore "array-contains" queries.
 * Splits by language separator to get keywords from both languages.
 */
export const generateSearchKeywords = (name, category) => {
    const keywords = new Set();
  
    // Helper to process text
    const processText = (text) => {
      if (!text) return;
      text.toString().toLowerCase().split(/\s+/).forEach(word => {
        if (word.length > 1) keywords.add(word);
      });
    };
  
    // Process name (may contain both languages separated by " / ")
    processText(name);
    processText(category);
  
    return Array.from(keywords);
  };
  
  /**
   * Formats product data to match the Firestore Schema.
   * Stores both combined and separated language versions.
   */
  export const formatProductForFirestore = (formData, uploadedImageUrls) => {
    // Extract separate language versions for better querying
    const nameEn = formData.nameEn?.trim() || '';
    const nameAr = formData.nameAr?.trim() || '';
    const descEn = formData.descriptionEn?.trim() || '';
    const descAr = formData.descriptionAr?.trim() || '';

    // Handle categories (ensure it's an array)
    const categories = Array.isArray(formData.categories) ? formData.categories : (formData.category ? [formData.category] : []);

    // Handle images: prefer uploaded images, fallback to existing URLs in formData (for CSV import)
    let finalImageUrls = [];
    if (uploadedImageUrls && uploadedImageUrls.length > 0) {
        finalImageUrls = uploadedImageUrls;
    } else if (formData.imageUrls && Array.isArray(formData.imageUrls)) {
        finalImageUrls = formData.imageUrls;
    } else if (formData.imageUrls && typeof formData.imageUrls === 'string') {
        finalImageUrls = [formData.imageUrls];
    }

    return {
      // Combined versions (for display)
      name: formData.name,
      description: formData.description,
      // Separate language versions (for querying/filtering)
      nameEn: nameEn,
      nameAr: nameAr,
      descriptionEn: descEn,
      descriptionAr: descAr,
      
      price: Number(formData.price),
      stock: Number(formData.stock || 0), // Main stock
      
      // Categories
      categories: categories,
      category: categories[0] || '', // Keep primary category for backward compatibility
      
      // Images
      imageUrls: finalImageUrls,
      imageUrl: finalImageUrls[0] || '', // Keep primary image for backward compatibility
      
      isBestSeller: formData.isBestSeller || false,
      isFeatured: formData.isFeatured || false,
      requiresPrescription: formData.requiresPrescription || false,
      
      searchKeywords: generateSearchKeywords(formData.name, categories.join(' ')),
      createdAt: new Date()
    };
  };
